// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Qs from "qs";
import * as Liff from "./liff/Liff.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "./Config.bs.js";
import * as Layout from "./Layout.bs.js";
import * as ProfileRoutes from "./profile/ProfileRoutes.bs.js";
import * as MemberMenuPage from "./MemberMenuPage.bs.js";
import * as ProfileContext from "./profile/ProfileContext.bs.js";
import * as ProfileReducer from "./profile/ProfileReducer.bs.js";
import * as ProfileEditPage from "./profile/ProfileEditPage.bs.js";
import * as ProfileCouponPage from "./profile/ProfileCouponPage.bs.js";
import * as ProfileRegisterPage from "./profile/ProfileRegisterPage.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as ProfileEditSuccessPage from "./profile/ProfileEditSuccessPage.bs.js";
import * as ProfileDeleteSuccessPage from "./profile/ProfileDeleteSuccessPage.bs.js";
import * as ProfileRegisterSuccessPage from "./profile/ProfileRegisterSuccessPage.bs.js";

import './App.css';
;

function App$MainApp(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var match = url.path;
  if (!match) {
    return React.createElement(ProfileRoutes.make, {});
  }
  switch (match.hd) {
    case "coupon" :
        if (!match.tl) {
          return React.createElement(ProfileCouponPage.make, {});
        }
        break;
    case "delete" :
        var match$1 = match.tl;
        if (match$1 && match$1.hd === "success" && !match$1.tl) {
          return React.createElement(ProfileDeleteSuccessPage.make, {});
        }
        break;
    case "edit" :
        var match$2 = match.tl;
        if (!match$2) {
          return React.createElement(ProfileEditPage.make, {});
        }
        if (match$2.hd === "success" && !match$2.tl) {
          return React.createElement(ProfileEditSuccessPage.make, {});
        }
        break;
    case "error" :
        if (!match.tl) {
          return React.createElement(Layout.$$Error.make, {});
        }
        break;
    case "member" :
        if (!match.tl) {
          return React.createElement(MemberMenuPage.make, {});
        }
        break;
    case "register" :
        if (!match.tl) {
          return React.createElement(ProfileRegisterPage.make, {});
        }
        break;
    case "success" :
        if (!match.tl) {
          return React.createElement(ProfileRegisterSuccessPage.make, {});
        }
        break;
    default:
      
  }
  return React.createElement("div", undefined, "Page Not Found");
}

var MainApp = {
  make: App$MainApp
};

function App$ProfileApp(Props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var search = Qs.parse(url.search);
  var match = React.useState(function () {
        return search.lead_in_channel;
      });
  var match$1 = React.useState(function () {
        return false;
      });
  var setError = match$1[1];
  var match$2 = React.useReducer(ProfileReducer.reducer, ProfileReducer.initial_state);
  var value_reducer = {
    state: match$2[0],
    dispatch: match$2[1]
  };
  var value_lead_in_channel = match[0];
  var value = {
    reducer: value_reducer,
    lead_in_channel: value_lead_in_channel
  };
  React.useEffect((function () {
          if (search.lead_in_channel == null) {
            Curry._1(setError, (function (param) {
                    return true;
                  }));
          }
          
        }), []);
  if (match$1[0]) {
    return React.createElement(Layout.$$Error.make, {});
  } else {
    return React.createElement(ProfileContext.Provider.make, {
                value: value,
                children: React.createElement(App$MainApp, {})
              });
  }
}

var ProfileApp = {
  make: App$ProfileApp
};

function App(Props) {
  return React.createElement(Liff.make, {
              options: Config.liff,
              app: App$ProfileApp
            });
}

var make = App;

export {
  MainApp ,
  ProfileApp ,
  make ,
  
}
/*  Not a pure module */
